import React from 'react';
import Dialog from '@mui/material/Dialog';

/**
 * StableMuiDialog
 * - Prevents closing on backdrop click.
 * - For all other reasons, delegates to provided onClose.
 */
export default function StableMuiDialog(props) {
  const { onClose, disableEscapeKeyDown, onExited, TransitionProps, ...rest } = props || {};
  return (
    <Dialog
      {...rest}
      TransitionProps={{ ...TransitionProps, onExited }}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return;
        if (disableEscapeKeyDown && reason === 'escapeKeyDown') return;
        onClose?.(event, reason);
      }}
    />
  );
}

